<template>
  <div class="settings-tab">
    <b-form v-if="isLoaded && detail">
      <div class="content-body">
        <div class="content-inside">
          <b-row no-gutters>
            <b-col sm="12" md="8">
              <div id="estore-settings" class="modal-form">
                <div v-if="isEnabledPointsView">
                  <b-row no-gutters>
                    <b-col sm="12" md="4">
                      <h6 class="main-label">Points</h6>
                    </b-col>
                    <b-col>
                      <b-form-group label-class="d-flex align-items-center">
                        <template slot="label">
                          Enable Points Earning
                          <i class="guide-tooltip" id="enable-points-earning-guide"></i>
                          <b-popover b-popover target="enable-points-earning-guide" triggers="hover"
                            content="When enabled, customers can earn points and redeem them at checkout. Set the minimum transaction value and its equivalent point/s. Disabling this will also turn off Pay with Points."
                          />
                          <switches id="toggle-points-earning" v-model="form.points_earning_enabled" theme="custom" color="primary" type-bold="true"
                            style="left: 10px; top: 10px" />
                        </template>
                      </b-form-group>
                      <div v-show="form.points_earning_enabled">
                        <b-form-group id="same-as-mechanics" v-if="hasLoyaltyExecution">
                          <b-form-checkbox id="points_same_as_merchanics" v-model="settings.points_same_as_merchanics"
                            name="points_same_as_merchanics" value="1" unchecked-value="0"
                            @input="evaluateSameAsMechanics">
                            <label for="points_same_as_merchanics" class="secondary-label mb-0 text-muted">Same as
                              mechanics</label>
                          </b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-class="d-flex align-items-center">
                          <template slot="label">
                            Earning
                            <i class="guide-tooltip" id="earning-guide"></i>
                            <b-popover target="earning-guide" triggers="hover"
                              content="Nominate the minimum transaction value and equivalent points that customers can earn."></b-popover>
                          </template>
                          <div class="form-container">
                            <b-row no-gutters>
                              <b-col cols="7">
                                <b-row>
                                  <b-col>
                                    <span class="d-block mb-2 up-label">Currency</span>
                                  </b-col>
                                </b-row>
                                <b-row no-gutters>
                                  <b-col cols="1 mr-1">
                                    <i class="icon d-block" style="margin-top: 9px">
                                      <img src="@/assets/images/mechanics/currency.svg" alt="Currency Icon" />
                                    </i>
                                  </b-col>
                                  <b-col class="p-1">
                                    <b-form-select v-model="settings.points_currency" :options="currencyOptions"
                                      :disabled="isSameAsMechanicsDisplay || !form.points_earning_enabled" />
                                  </b-col>
                                  <b-col class="p-1">
                                    <b-form-group>
                                      <div class="d-flex position-relative">
                                        <b-form-input type="number" :formatter="pointsFormatter" placeholder="0" min="1"
                                          max="9999" maxlength="4" value="0" step="1"
                                          v-model="settings.points_currency_value" :disabled="isSameAsMechanicsDisplay || !form.points_earning_enabled"
                                          :class="{ 'text-muted': isSameAsMechanicsDisplay }" ref="earningCurrency"
                                          @keypress.native="trimExcessMaxLength">
                                        </b-form-input>
                                        <div class="input-controls position-absolute d-inline-flex flex-column h-100">
                                          <b-button class="value-control -up"
                                            @click="controlValue('points_currency_value', 'up', 'earningCurrency')"></b-button>
                                          <b-button class="value-control -down"
                                            @click="controlValue('points_currency_value', 'down', 'earningCurrency')"></b-button>
                                        </div>
                                      </div>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col cols="1">
                                <i class="icon mx-auto d-block" style="margin-top: 4px">
                                  <img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon"
                                    style="margin-top: 36px" />
                                </i>
                              </b-col>
                              <b-col>
                                <b-row>
                                  <b-col>
                                    <span class="d-block mb-2 up-label">Points</span>
                                  </b-col>
                                </b-row>
                                <b-row no-gutters>
                                  <b-col cols="2">
                                    <i class="icon d-block" style="margin-top: 9px">
                                      <img src="@/assets/images/mechanics/points.svg" alt="Points Icon" />
                                    </i>
                                  </b-col>
                                  <b-col class="py-1">
                                    <b-form-group>
                                      <b-form-input type="number" disabled class="text-muted" :formatter="pointsFormatter"
                                        v-model="settings.points_value" style="
                                        background-color: #e9ecef;
                                        opacity: 1;
                                      "></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </div>
                        </b-form-group>
                        <PayWithPointsComponent
                          ref="payWithPointsComponent"
                          :setup="pay_with_points_setup"
                          :isSameAsMechanics="isSameAsMechanicsDisplay"
                          :isPointsEarningEnabled="form.points_earning_enabled"
                          @setPayWithPoints="setPayWithPoints"
                          @getPointsMechanics="evaluateSameAsMechanics" />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-show="form.points_earning_enabled">
                      <b-col offset="4" class="pl-0">
                        <div class="mb-1">Points Expiry</div>
                        <switches
                            id="toggle-points-expiry"
                            v-model="form.points_expiry"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            style="top: -15px;"
                            text-enabled="On"
                            text-disabled="Off">
                        </switches>
                    </b-col>
                    <b-col>
                      <b-form-group :invalid-feedback="errorMessage('points_expiry_duration')">
                        <div class="mb-1">Validity</div>
                        <b-form-select
                          v-model="form.points_expiry_duration"
                          :options="pointsExpiryDurationOptions"
                          text-enabled="On"
                          text-disabled="Off"
                          :disabled="!form.points_expiry"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                </div>
                <b-row no-gutters>
                  <b-col sm="12" md="4">
                    <h6 class="main-label">SKU Stock</h6>
                  </b-col>
                  <b-col>
                    <div v-if="!isValid('sku')" style="color: red; font-size: 10px; margin-left: 60px">
                      {{ errorMessage("sku") }}
                    </div>
                    <p>
                      To allow unlimited stocks for SKU's, turn this option off.
                    </p>
                    <switches id="toggle-sku" v-model="enabledSku" theme="custom" color="primary" type-bold="true" text-enabled="On"
                      text-disabled="Off"></switches>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <hr class="form-divider mb-4" />
                  </b-col>
                </b-row>
                <template v-if="isEStoreWebChannelEnabled && detail.settings.is_payment_express_enabled">
                  <b-row no-gutters>
                    <b-col sm="12" md="4">
                      <div class="main-label">
                        Payment Express
                        <i class="guide-tooltip align-middle ml-1" id="earning-guide" v-b-popover.hover="'When enabled, your front-liners can use the RUSH Merchant App to generate a payment QR code that your customers can scan to pay. This is recommended for in-person transactions.'
                          ">
                        </i>
                      </div>
                    </b-col>
                    <b-col>
                      <switches id="toggle-payment-express" v-model="form.is_payment_express_enabled" theme="custom" color="primary"
                        type-bold="true" text-enabled="On" text-disabled="Off" style="bottom: 20px" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider mb-4" />
                    </b-col>
                  </b-row>
                </template>
                <b-row no-gutters>
                  <b-col sm="12" md="4">
                    <h6 class="main-label">Brand Categories</h6>
                  </b-col>
                  <b-col>
                    <div v-if="!isValid('brand_categories')" style="color: red; font-size: 10px; margin-left: 60px">
                      {{ errorMessage("brand_categories") }}
                    </div>
                    <b-row no-gutters v-for="(category, index) in settings.brand_categories" :key="index">
                      <b-col>
                        <b-row no-gutters>
                          <b-col>
                            <b-form-group :label="'Category ' + (index + 1)" class="mt-1 secondary-label"
                              :invalid-feedback="errorMessage(
                                'brand_categories.' + index + '.name'
                              )
                                ">
                              <b-form-input ref="category" v-model="category.name"
                                placeholder="Enter category"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="1">
                            <img src="../../assets/images/actions/delete.svg" alt="Delete Button"
                              class="action-button estore-delete-category" v-bind:class="{ 'd-none': index === 0 }"
                              @click="deleteBrandCategory(index)" />
                          </b-col>
                        </b-row>
                        <b-row class="d-none" no-gutters v-for="(
                            sub_category, sub_index
                          ) in category.sub_categories" :key="sub_index">
                          <b-col cols="2">
                            <label for class="secondary-label" style="margin-top: 13px">Sub Category</label>
                          </b-col>
                          <b-col>
                            <b-form-group class="mt-1">
                              <b-form-input :ref="'brand_sub_category_' +
                                index +
                                '_' +
                                sub_index
                                " v-model="sub_category.name" placeholder="Enter sub category"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button"
                              style="margin-top: 11px; margin-left: 8px" v-bind:class="{
                                'd-none':
                                  sub_index == 0 ||
                                  sub_index ==
                                  category.sub_categories.length - 1,
                              }" @click="deleteBrandSubCategory(index, sub_index)" />
                            <img src="../../assets/images/icons/add.svg" class="action-button"
                              style="margin-top: 13px; margin-left: 10px" alt="Add Icon" v-bind:class="{
                                'd-none':
                                  (sub_index == 0 &&
                                    category.sub_categories.length > 1) ||
                                  sub_index <
                                  category.sub_categories.length - 1,
                              }" @click="addBrandSubCategory(index, sub_index)" />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row no-gutters>
                      <b-col cols="11">
                        <hr class="form-divider mt-2" />
                        <div style="cursor: pointer" @click="addBrandCategory()">
                          <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg"
                            alt="Add Icon" />
                          <label for="brand-category" style="cursor: pointer"
                            class="add-branch-label ml-2 d-inline-block align-middle">Add a
                            Category</label>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <hr class="form-divider mb-4" />
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col sm="12" md="4">
                    <h6 class="main-label">Product Categories</h6>
                  </b-col>
                  <b-col>
                    <div v-if="!isValid('categories')" style="color: red; font-size: 10px; margin-left: 60px">
                      {{ errorMessage("categories") }}
                    </div>
                    <div id="category-switch" class="d-block" style="margin-bottom: 36px" v-if="
                      env == 'Development' ||
                      env == 'Canary' ||
                      env == 'local' ||
                      env == 'Staging'
                    ">
                      <switches id="toggle-product-categories" v-model="settings.categories_enable" theme="custom" color="primary" type-bold="true"
                        text-enabled="On" text-disabled="Off" style="position: absolute; top: -18px"></switches>
                    </div>
                    <b-row no-gutters v-for="(category, index) in settings.categories" :key="index">
                      <b-col>
                        <b-row no-gutters>
                          <b-col>
                            <b-form-group :label="'Category ' + (index + 1)" class="mt-1 secondary-label"
                              :invalid-feedback="errorMessage('categories.' + index + '.name')
                                ">
                              <b-form-input ref="category" v-model="category.name"
                                placeholder="Enter category"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="1">
                            <img src="../../assets/images/actions/delete.svg" alt="Delete Button"
                              class="action-button estore-delete-category" v-bind:class="{ 'd-none': index === 0 }"
                              @click="deleteCategory(index)" />
                          </b-col>
                        </b-row>
                        <b-row class="d-none" no-gutters v-for="(
                            sub_category, sub_index
                          ) in category.sub_categories" :key="sub_index">
                          <b-col cols="2">
                            <label for class="secondary-label" style="margin-top: 13px">Sub Category</label>
                          </b-col>
                          <b-col>
                            <b-form-group class="mt-1">
                              <b-form-input :ref="'sub_category_' + index + '_' + sub_index" v-model="sub_category.name"
                                placeholder="Enter sub category"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button"
                              style="margin-top: 11px; margin-left: 8px" v-bind:class="{
                                'd-none':
                                  sub_index == 0 ||
                                  sub_index ==
                                  category.sub_categories.length - 1,
                              }" @click="deleteSubCategory(index, sub_index)" />
                            <img src="../../assets/images/icons/add.svg" class="action-button"
                              style="margin-top: 13px; margin-left: 10px" alt="Add Icon" v-bind:class="{
                                'd-none':
                                  (sub_index == 0 &&
                                    category.sub_categories.length > 1) ||
                                  sub_index <
                                  category.sub_categories.length - 1,
                              }" @click="addSubCategory(index, sub_index)" />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row no-gutters>
                      <b-col cols="11">
                        <hr class="form-divider mt-2" />
                        <div style="cursor: pointer" @click="addCategory()">
                          <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg"
                            alt="Add Icon" />
                          <label for="category" style="cursor: pointer"
                            class="add-branch-label ml-2 d-inline-block align-middle">Add a
                            Category</label>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <hr class="form-divider mb-4" />
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col sm="12" md="4">
                    <span class="main-label">Radius</span>
                  </b-col>
                  <b-col>
                    <switches id="toggle-radius" v-model="form.radius_enable" theme="custom" color="primary" type-bold="true"
                      text-enabled="On" text-disabled="Off" style="top: -23px" />
                    <div class="instruction-info">
                      <img src="@/assets/images/icons/blue-filled-rounded-i.png" alt="Information" />
                      <span>
                        Turn this off allows to display all branches.
                      </span>
                    </div>
                    <b-row>
                      <b-col md="5">
                        <b-form-group label="Radius" class="secondary-label" :invalid-feedback="errorMessage('radius')">
                          <b-input-group prepend="km">
                            <b-input ref="radius" v-model="settings.radius" placeholder="0" type="number" min="1"
                              style="font-size: 1rem" :disabled="!form.radius_enable" />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <hr class="form-divider mb-4" />
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col sm="12" md="4">
                    <h6 class="main-label">Fees</h6>
                  </b-col>
                  <b-col>
                    <div id="category-switch" class="d-block" style="margin-bottom: 36px">
                      <switches id="toggle-fees" @change="showFees()" v-model="displayFees" theme="custom" color="primary"
                        type-bold="true" text-enabled="On" text-disabled="Off" style="position: absolute; top: -18px">
                      </switches>
                    </div>
                    <b-row>
                      <b-col>
                        <div id="fees-container" class="d-none" :class="{ 'd-block': displayFees }">
                          <div class="fees-collapse-container mt-3" v-for="(fee, index) in settings.fees" :key="index">
                            <div class="fee-header">
                              <input type="text" class="fee-title" placeholder="Enter fee title" maxlength="50"
                                v-model="fee.name" :ref="'input' + index" @click="editFeeTitle(index)" />
                              <label for="edit-fee-title" style="cursor: pointer"
                                class="add-branch-label mx-2 d-inline-block align-middle" v-if="isFeeTitle"
                                @click="editFeeTitle(index)">Done</label>
                              <img src="@/assets/images/actions/edit.svg" alt="Edit Icon" class="mr-2"
                                @click="editFeeTitle(index)" style="cursor: pointer" v-else />
                              <img src="../../assets/images/actions/delete.svg" alt="Delete Icon" class="mr-2" @click="
                                deleteFee(settings.fees[index].uuid, index)
                                " style="cursor: pointer" />
                              <switches :id="`toggle-fee-${index + 1}`" v-model="fee.active" theme="custom" color="primary" type-bold="true"
                                text-enabled="On" text-disabled="Off" style="margin: -18px 1px"></switches>
                              <img src="@/assets/images/icons/arrow-up.svg" alt="Collapsed Icon"
                                class="mx-3 when-closed" style="
                                  width: 14px;
                                  height: 14px;
                                  cursor: pointer;
                                " v-b-toggle="'fee' + index" />
                            </div>
                            <b-form-invalid-feedback class="px-4" :force-show="!!errorMessage('name', 'fees', index)">
                              {{ errorMessage('name', 'fees', index) }}
                            </b-form-invalid-feedback>
                            <div class="fee-body">
                              <b-collapse :id="'fee' + index" visible class="mt-2" style="padding: 14px 24px">
                                <b-row>
                                  <b-col cols="3">
                                    <b-form-group label="Value" class="mt-1 secondary-label"
                                      :invalid-feedback="errorMessage('value_type', 'fees', index)">
                                      <b-form-select v-model="fee.value_type" :options="feeOptions"></b-form-select>
                                    </b-form-group>
                                  </b-col>
                                  <b-col cols="9">
                                    <b-form-group label="Price" class="mt-1 secondary-label"
                                      :invalid-feedback="errorMessage('value', 'fees', index)">
                                      <b-form-input v-model="fee.value" type="number" placeholder="Enter price" min="1"
                                        step=".01"></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-collapse>
                            </div>
                          </div>
                          <div class="mt-4" style="cursor: pointer" @click="addNewFee()">
                            <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg"
                              alt="Add Icon" />
                            <label for="new-fee" style="cursor: pointer"
                              class="add-branch-label ml-2 d-inline-block align-middle">
                              Add New Fee
                            </label>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template v-if="!isGlifeOnly()">
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="4">
                      <h6 class="main-label">Mode of Payment</h6>
                    </b-col>
                    <b-col>
                      <b-row no-gutters>
                        <b-col>
                          <b-row no-gutters>
                            <b-col>
                              <div v-if="!isValid('payment_type')" style="
                                  color: red;
                                  font-size: 10px;
                                  margin-bottom: 20px;
                                ">
                                {{ errorMessage("payment_type") }}
                              </div>
                              <b-form-group>
                                <b-form-checkbox-group id="paymentType" v-model="settings.payment_type"
                                  :options="paymentOptionsDisplay" name="paymentType" stacked @change="
                                    showPaymentFacility(settings.payment_type)
                                    "></b-form-checkbox-group>
                                    <b-form-invalid-feedback :state="isValid('payment_type')"
                                      v-if="isValid('payment_type')">
                                      This field is required.
                                    </b-form-invalid-feedback>
                              </b-form-group>
                              <div id="bank-account-container"
                                :class="['d-none', { 'd-block mt-2': isPaymentFacility }]"
                                v-for="(bank, index) in settings.bank_accounts" :key="index">
                                <div class="bank-name-container" v-b-toggle="'paymentFacility' + index">
                                  <span>{{ bank.bank }}</span>
                                  <img src="@/assets/images/icons/arrow-up.svg" alt="Collapsed Icon"
                                    class="mr-3 when-closed" style="width: 14px; height: 14px" />
                                </div>
                                <b-collapse :id="'paymentFacility' + index" visible class="mt-2 bank-form">
                                  <b-form-group label="Bank" class="mt-1 secondary-label"
                                    :invalid-feedback="errorMessage('bank', 'paymentFacilities', index)">
                                    <b-form-select v-model="bank.bank" :options="bankOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group label="Account Name" class="mt-1 secondary-label"
                                    :invalid-feedback="errorMessage('account_name', 'paymentFacilities', index)">
                                    <b-form-input v-model="bank.account_name" :formatter="formatAccountName"
                                      placeholder="Enter account name"></b-form-input>
                                  </b-form-group>
                                  <b-form-group label="Account Number" class="mt-1 secondary-label"
                                    :invalid-feedback="errorMessage('account_no', 'paymentFacilities', index)">
                                    <b-form-input type="number" v-model="bank.account_no"
                                      :formatter="formatAccountNumber"
                                      placeholder="Enter account number"></b-form-input>
                                  </b-form-group>
                                  <input type="hidden" v-model="bank.uuid" />
                                </b-collapse>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row no-gutters class="mt-4 d-none" :class="{ 'd-block': isPaymentFacility }">
                            <b-col cols="11">
                              <div style="cursor: pointer" @click="addPaymentFacility()">
                                <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg"
                                  alt="Add Icon" />
                                <label for="add-bank" style="cursor: pointer"
                                  class="add-branch-label ml-2 d-inline-block align-middle">Add Bank</label>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </template>
                <b-row>
                  <b-col>
                    <hr class="form-divider" />
                  </b-col>
                </b-row>
                <CancelOrderButtonSection ref="CancelOrderButtonSection" :formData="form"
                  :cancellationReasons="cancellationReasons" :cancelOptionErrors="cancelOptionErrors" />
                <b-row>
                  <b-col>
                    <hr class="form-divider" />
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col sm="12" md="4" class="sd-title ">
                    <div class="d-flex align-items-center">
                      <h6 class="main-label">Special Discounts</h6>
                      <i class="base-tooltip" aria-hidden="true"
                        v-b-popover.hover="'When enabled, this feature allows the product item to be marked down using special discounts.'"
                        style="margin-top: 1px;"></i>
                    </div>
                  </b-col>
                  <b-col style="margin-top: -19px; position: relative">
                    <div class="sd-switch" style="">
                      <div class="d-flex align-items-center">
                        <span class=""
                          style="margin-bottom: 2px; margin-right: 12px; font-family: MainFontRegular, sans-serif;">Enable</span>
                        <switches style="margin-top: 2px;" v-model="settings.special_discount_enable" theme="custom"
                          color="primary" type-bold="true" text-enabled="On" text-disabled="Off" />
                      </div>
                      <div v-if="settings.special_discount_enable">
                        <div class="sd-options" style=" p { margin-bottom: 0;}.form-group {margin-bottom: 2px;}">
                          <span style="font-family: MainFontRegular, sans-serif; font-size: 16px;">Applicable to specific
                            channel</span>
                          <b-form-group class="pt-2"> <b-form-checkbox-group id="specialDiscountChannel"
                              v-model="settings.special_discount[0].channels"
                              :options="special_discounts.sdChannelOptions" name="specialDiscountChannel" stacked>
                              <b-form-invalid-feedback :state="special_discounts.sdChannelsError"
                                v-if="special_discounts.sdChannelsError">
                                This field is required.
                              </b-form-invalid-feedback>
                            </b-form-checkbox-group></b-form-group>
                        </div>
                        <div class="sd-options">
                          <span style="font-family: MainFontRegular, sans-serif; font-size: 16px;">User type discount</span>
                          <b-form-group class="pt-2"><b-form-checkbox-group id="specialDiscountDiscountType"
                              v-model="settings.special_discount[0].discount_types"
                              :options="special_discounts.sdDiscountTypeOptions" name="specialDiscountDiscountType"
                              stacked>
                              <b-form-invalid-feedback :state="special_discounts.sdDiscountTypesError"
                                v-if="special_discounts.sdDiscountTypesError">
                                This field is required.
                              </b-form-invalid-feedback>
                            </b-form-checkbox-group></b-form-group>
                        </div>

                        <div class="sd-options">
                          <span style="font-family: MainFontRegular, sans-serif; font-size: 16px;">Discount terms</span>
                          <b-form-group class="pt-2">
                            <div class="d-flex align-items-center">
                              <div> <b-form-radio v-model="settings.special_discount[0].discount_terms"
                                  name="specialDiscountDiscountTerms" value="per_net">
                                </b-form-radio></div>
                              <span
                                style="font-family: MainFontRegular, sans-serif; margin-top: 5px; margin-left: 7px">Apply
                                discount to
                                subtotal</span>
                            </div>
                            <div class="d-flex align-items-center"> <b-form-radio
                                v-model="settings.special_discount[0].discount_terms"
                                name="specialDiscountDiscountTerms" value="per_item">
                              </b-form-radio>
                              <span style="font-family: MainFontRegular, sans-serif; margin-top: 5px; margin-left: 7px">
                                Apply discount per
                                item</span>
                            </div>
                            <b-form-invalid-feedback :state="special_discounts.sdDiscountTermsError"
                              v-if="special_discounts.sdDiscountTermsError">
                              This field is required.
                            </b-form-invalid-feedback>
                            <div class="" style="margin-top: 5px; margin-left: 31px;"
                              v-if="settings.special_discount[0].discount_terms == 'per_item'">
                              <div class="d-flex align-items-center"><b-form-radio
                                  v-model="settings.special_discount[0].discount_terms_item"
                                  name="specialDiscountDiscountTermsItem" value="highest">
                                </b-form-radio>
                                <span style="font-family: MainFontRegular, sans-serif; margin-top: 5px; margin-left: 7px">
                                  Highest value in
                                  the cart</span>
                              </div>

                              <div class="d-flex align-items-center">
                                <b-form-radio v-model="settings.special_discount[0].discount_terms_item"
                                  name="specialDiscountDiscountTermsItem" value="lowest">

                                </b-form-radio>
                                <span
                                  style="font-family: MainFontRegular, sans-serif; margin-top: 5px; margin-left: 7px">Lowest
                                  value in
                                  the cart</span>
                              </div>
                              <div class="d-flex align-items-center">
                                <b-form-radio v-model="settings.special_discount[0].discount_terms_item"
                                  name="specialDiscountDiscountTermsItem" value="manual">
                                </b-form-radio>
                                <span
                                  style="font-family: MainFontRegular, sans-serif; margin-top: 5px; margin-left: 7px">Manually
                                  select
                                  via MMA</span>
                              </div>
                              <b-form-invalid-feedback :state="special_discounts.sdDiscountTermsItemError"
                                v-if="special_discounts.sdDiscountTermsItemError">
                                This field is required.
                              </b-form-invalid-feedback>
                            </div>
                          </b-form-group>

                        </div>
                      </div>

                    </div>

                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="12" md="4"></b-col>
          </b-row>
        </div>
      </div>
    </b-form>
    <b-container v-else class="mt-3 lead text-center"> Loading... </b-container>
    <b-modal ref="myModalRef" title="Confirm Changes" centered>
      <p class="modal-main-message">
        Do you want to save the changes you made?
      </p>
      <div slot="modal-footer">
        <b-button variant="light" v-bind:disabled="loading" class="text-dark font-weight-bold border"
          style="margin-right: 0.25rem" @click="hideModal('delete-modal')">Cancel</b-button>
        <b-button variant="primary" v-bind:disabled="loading" style="margin-left: 0.25rem" @click="sendForm()">
          <template v-if="loading">Saving...</template>
          <template v-else>Save</template>
        </b-button>
      </div>
    </b-modal>
    <fixed-bottom-container v-show="isLoaded">
      <b-row>
        <b-col md="2" offset-md="10">
          <b-button variant="primary" class="btn-pill" size="lg" block @click="validateData">
            Save
          </b-button>
        </b-col>
      </b-row>
    </fixed-bottom-container>
  </div>
</template>

<script>
import Switches from "vue-switches-2";
import { mapState, mapGetters, mapMutations } from "vuex";
import { subscriptionChannels } from "@/mixins/subscription_channels";
import _ from "lodash";
import FixedBottomContainer from "@/components/common/FixedBottomContainer";
import CancelOrderButtonSection from "@/components/settings/CancelOrderButtonSection.vue";
import PayWithPointsComponent from "@/components/settings/PayWithPoints.vue";

export default {
  data() {
    return {
      isLoaded: false,
      form: {
        points_same_as_merchanics: "not_accepted",
        points_currency: "PHP",
        points_currency_value: 1,
        points_value: 0,
        store_name: "",
        store_description: "",
        categories_enable: true,
        brand_categories_enable: true,
        cancellationOptions: [
          {
            value: "Order is taking too long to process",
            identifier: 1
          }
        ],
        cancel_order_enable: 1,
        disable_cancel: 0,
        disable_cancel_seconds: null,
        is_payment_express_enabled: false,
        radius_enable: false,
        points_expiry: false,
        points_expiry_duration: null,
        points_earning_enabled: false
      },
      currencyOptions: ["PHP", "USD"],
      temporaryCategoryCounter: 1,
      temporarySubCategoryCounter: 1,
      temporaryCategories: [
        {
          id: "0",
          uuid: null,
          name: "",
          sub_categories: []
        }
      ],
      temporarySubCategories: [
        [
          {
            id: "0-0",
            uuid: null,
            name: ""
          }
        ]
      ],
      mop: "",
      brandCategories: [
        {
          name: ""
        }
      ],
      productCategories: [
        {
          name: ""
        }
      ],
      paymentTypeSelected: [],
      paymentFacility_enable: true,
      bankOptions: [
        { text: "Asia United Bank Corporation", value: "AUB" },
        { text: "BDO Unibank, Inc.", value: "BDO" },
        { text: "Bank of Commerce", value: "BC" },
        { text: "Bank of the Philippine Islands", value: "BPI" },
        { text: "China Banking Corporation", value: "CBC" },
        { text: "CTBC Bank  (Philippines) Corporation", value: "CTBC" },
        { text: "Development Bank of the Philippines", value: "DBP" },
        { text: "East West Banking Corporation", value: "EWBC" },
        { text: "Equicom Savings Bank, Inc.", value: "ESBI" },
        { text: "Land Bank of the Philippines", value: "LBP" },
        { text: "Maybank Philippines, Incorporated", value: "MPI" },
        { text: "Metropolitan Bank & Trust Company", value: "MBTC" },
        { text: "Philippine Bank of Communications", value: "PBC" },
        { text: "Philippine National Bank", value: "PNB" },
        { text: "PNB Savings Bank", value: "PNBSB" },
        { text: "Philippine Savings Bank", value: "PSB" },
        { text: "Rizal Commercial Banking Corporation", value: "RCBC" },
        { text: "Robinsons Bank Corporation", value: "RBC" },
        { text: "Security Bank Corporation", value: "SBC" },
        {
          text: "Sterling Bank of Asia, Inc. (A Savings Bank)",
          value: "Sterling"
        },
        { text: "Union Bank of the Philippines", value: "UBP" },
        { text: "United Coconut Planters Bank", value: "UCPB" },
        { text: "UCPB Savings Bank", value: "UCPBSB" },
        { text: "GCASH", value: "GCASH" }
      ],
      isPaymentFacility: false,
      displayFees: true,
      isFeeTitle: false,
      feeOptions: ["PHP", "%"],
      env: process.env.VUE_APP_MODE,
      enable: true,
      radius: 8,
      enabledSku: true,
      cancellationReasons: [
        {
          value: null,
          placeholder: "Select a reason",
          identifier: null
        },
        { value: "Order is taking too long to process", identifier: 1 },
        {
          value: "Need to change items in my Order Basket",
          identifier: 1
        },
        { value: "Need to change Delivery Address", identifier: 1 },
        { value: "Need to change Mode of Payment", identifier: 1 },
        { value: "", placeholder: "(Create new reason)", identifier: 0 }
      ],
      cancelOptionErrors: {},
      special_discounts: {
        sdChannelOptions: [
          { text: "eStore", value: "estore" },
          { text: "Scan to Order", value: "sto" }
        ],
        sdDiscountTypeOptions: [
          { text: "Senior Citizen", value: "senior" },
          { text: "PWD", value: "pwd" }
        ],
        sdChannelsError: false,
        sdDiscountTypesError: false,
        sdDiscountTermsError: false,
        sdDiscountTermsItemError: false
      },
      pay_with_points_setup: {
        pay_with_points_currency: "PHP",
        pay_with_points_currency_value: 1,
        pay_with_points_value: 1,
        pay_with_points_estore_enabled: false,
        pay_with_points_sto_enabled: false,
        pay_with_points_stp_enabled: false,
        pay_with_points_ca_enabled: false
      },
      pointsExpiryDurationOptions: [
        { value: "+3 months", text: "3 Months" },
        { value: "+6 months", text: "6 Months" },
        { value: "+1 year", text: "1 Year" },
        { value: "+2 years", text: "2 Years" },
        { value: "+3 years", text: "3 Years" },
        { value: "+4 years", text: "4 Years" },
        { value: "+5 years", text: "5 Years" },
        { value: "+10 years", text: "10 Years" },
        { value: "+15 years", text: "15 Years" }
      ]
    };
  },
  mixins: [subscriptionChannels],
  async created() {
    await this.viewSettings();
    await this.getBrands();
    await this.$store.dispatch("estoreSettings/getLoyaltyVisibility");

    if (this.detail.name == "CafeFrance") this.removeGCashFromBankOptions();

    await this.$store.dispatch("payments/getPaymentGateway");

    this.isLoaded = true;
  },
  computed: {
    ...mapState("estoreSettings", [
      "loading",
      "settings",
      "errors",
      "payment_type",
      "bank_accounts",
      "brands"
    ]),
    ...mapState("accountProfile", ["detail"]),
    ...mapGetters("auth", ["user"]),
    ...mapGetters({
      paymentGatewayLoading: "payments/loading",
      paymentGatewayData: "payments/paymentGatewayData",
      isEnabledPointsView: "estoreSettings/isEnabledPointsView"
    }),
    ...mapGetters("accountProfile", [
      "planChannels",
      "isEStoreWebChannelEnabled",
      "planDetails"
    ]),
    hasLoyaltyExecution: {
      get() {
        return _.get(this.planDetails, "enable_loyalty", false);
      },
      set(value) {
        return value;
      }
    },
    paymentOptionsDisplay: {
      get() {
        if (
          !this.paymentGatewayLoading &&
          !_.isEmpty(this.paymentGatewayData)
        ) {
          let payments = ["COD", "CP", "CC", "UNIONBANK", "QRPH", "PAYMAYA", "GCASH", "GRAB_PAY", "SHOPEEPAY"];
          let sortedPayments = [];
          
          payments.forEach(p => {
            this.paymentGatewayData.payment_methods.forEach(pm => {
              if (pm.includes(p)) {
                sortedPayments.push(pm);
              }
            })
          });

          this.paymentGatewayData.payment_methods = sortedPayments;
          return this.paymentGatewayData.payment_methods.map(type => {
            const option = {
              content: "",
              value: type
            };
            if (type === "COD") option["text"] = "Cash on Delivery";
            else if (type === "CP") option["text"] = "Cash Payment";
            else if (type.includes("CC"))
              option["text"] = "Credit Card";
            else if (type.includes("GRAB_PAY"))
              option["text"] = "GrabPay";
            else if (type.includes("GCASH"))
              option["text"] = "GCash";
            else if (type.includes("PAYMAYA"))
              option["text"] = "Maya";
            else if (type.includes("SHOPEEPAY"))
              option["text"] = "ShopeePay";
            else if (type.includes("QRPH"))
              option["text"] = "QR Ph"
            else if (type.includes("UNIONBANK"))
              option["text"] = "UnionBank – Direct Debit"
            return option;
          });
        } else return [];
      },
      set(options) {
        return options;
      }
    },
    isSameAsMechanicsDisplay: {
      get() {
        return Boolean(this.settings.points_same_as_merchanics / 1);
      },
      set(value) {
        return value;
      }
    }
  },
  components: {
    Switches,
    FixedBottomContainer,
    CancelOrderButtonSection,
    PayWithPointsComponent
  },
  watch: {
    settings: {
      deep: true,
      handler: function (value) {
        this.showPaymentFacility(value.payment_type);
      }
    },
    "form.points_expiry"(value) {
      if (!value) this.form.points_expiry_duration = null;
    }
  },
  methods: {
    ...mapMutations({ setErrors: "estoreSettings/errors" }),
    removeGCashFromBankOptions() {
      for (let index = 0; index < this.bankOptions.length; index++) {
        if (this.bankOptions[index].value == "GCASH") {
          this.bankOptions.splice(index, 1);
        }
      }
    },
    async viewSettings() {
      let _this = this;
      await this.$store
        .dispatch("estoreSettings/viewSettings")
        .then(() => {
          if (this.settings.limited_stock == 0) {
            this.settings.limited_stock = false;
            this.enabledSku = false;
          } else {
            this.settings.limited_stock = true;
            this.enabledSku = true;
          }

          if (typeof this.settings.radius_enable !== "boolean") {
            if (this.settings.radius_enable === "0")
              this.form.radius_enable = false;
            if (this.settings.radius_enable === "1")
              this.form.radius_enable = true;
          } else
            this.form.radius_enable = this.settings.radius_enable;

          // Start: Set Cancel Order Button
          this.form.cancel_order_enable = Number(
            this.settings.cancel_order_enable
          );

          if (
            _.get(this.settings, "cancellation_reasons.length", 0) >
            0
          ) {
            this.form.cancellationOptions = this.settings.cancellation_reasons.map(
              option => {
                return {
                  value: option,
                  identifier: this.cancellationReasons
                    .map(reason => reason.value)
                    .includes(option)
                    ? 1
                    : 0
                };
              }
            );
          }
          // End: Set Cancel Order Button

          // Start: Set Cancel Order Visibility Settings
          this.form.disable_cancel = Number(this.settings.disable_cancel);
          this.form.disable_cancel_seconds = Number(this.settings.disable_cancel_seconds);
          // End: Set Cancel Order Visibility Settings

          if (
            typeof this.settings.is_payment_express_enabled !==
            "boolean"
          ) {
            if (this.settings.is_payment_express_enabled === "0")
              this.form.is_payment_express_enabled = false;
            if (this.settings.is_payment_express_enabled === "1")
              this.form.is_payment_express_enabled = true;
          } else {
            this.form.is_payment_express_enabled = this.settings.is_payment_express_enabled;
          }

          _this.form.points_expiry = Boolean(this.settings.points_expiry / 1);
          _this.form.points_expiry_duration = this.settings.points_expiry_duration;
          _this.form.points_earning_enabled = Boolean(this.settings.points_earning_enabled / 1);
          _this.checkBrandEnable();
          _this.setPayWithPointsSetup();
        });
    },
    checkBrandEnable() {
      if (this.settings.brand_enable == 1) {
        this.enable = true;
      } else {
        this.enable = false;
      }
    },
    setPayWithPointsSetup() {
      const {
        pay_with_points_value,
        pay_with_points_currency,
        pay_with_points_currency_value,
        pay_with_points_estore_enabled,
        pay_with_points_sto_enabled,
        pay_with_points_stp_enabled,
        pay_with_points_ca_enabled
      } = this.settings;

      this.pay_with_points_setup = {
        pay_with_points_currency: pay_with_points_currency,
        pay_with_points_currency_value: pay_with_points_currency_value / 1 ? pay_with_points_currency_value : 1,
        pay_with_points_value: pay_with_points_value / 1 ? pay_with_points_value : 1,
        pay_with_points_estore_enabled: Boolean(pay_with_points_estore_enabled / 1),
        pay_with_points_sto_enabled: Boolean(pay_with_points_sto_enabled / 1),
        pay_with_points_stp_enabled: Boolean(pay_with_points_stp_enabled / 1),
        pay_with_points_ca_enabled: Boolean(pay_with_points_ca_enabled / 1)
      };
    },
    async getBrands() {
      await this.$store.dispatch("estoreSettings/getBrands");
    },
    showPaymentFacility(paymentSelected) {
      if (paymentSelected != null) {
        if (paymentSelected.includes("BT")) {
          this.isPaymentFacility = true;
        } else {
          this.isPaymentFacility = false;
        }
      }
    },
    showFees() {
      return !this.displayFees;
    },
    editFeeTitle() {
      this.isFeeTitle = !this.isFeeTitle;
    },
    addNewFee() {
      const hasPreviousErrors = this.errors && this.errors.errors.fees;

      if (hasPreviousErrors) delete this.errors.errors.fees;

      if (this.settings.fees.length <= 9) {
        this.settings.fees.push({
          name: "",
          value_type: "",
          value: 0.0,
          active: true
        });
      } else {
        alert("Only 10 fees are allowed.");
      }

      if (hasPreviousErrors) this.validateFees();
    },
    deleteFee(uuid, index) {
      this.settings.fees.splice(index, 1);
    },
    formatAccountName(e) {
      return String(e).substring(0, 50);
    },
    formatAccountNumber(e) {
      return String(e).substring(0, 20);
    },
    errorMessage(field, type = null, index = null) {
      if (this.errors == null) {
        return "";
      } else if (this.errors.errors[type] && !!type && index !== null) {
        return this.errors.errors[type][index][field];
      } else return this.errors.errors[field];
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }

      return Boolean(this.errors.errors[field]);
    },
    async validatePointsSection() {
      const isAllowed = [];
      const fieldRequiredError = "This field is required.";
      if (!this.$refs.earningCurrency.checkValidity()) {
        this.$refs.earningCurrency.reportValidity();
        isAllowed.push(false);
      }

      const payWithPointsRef = this.$refs.payWithPointsComponent.$refs.payWithPointsCurrency;

      if (
        this.$refs.earningCurrency.checkValidity() &&
        payWithPointsRef &&
        !payWithPointsRef.checkValidity()
      ) {
        payWithPointsRef.reportValidity();
        isAllowed.push(false);
      }

      if (this.form.points_expiry && !this.form.points_expiry_duration) {
        this.updateErrors("points_expiry_duration", fieldRequiredError);
        isAllowed.push(false);
      }

      await this.$root.$emit("validatePayWithPoints");
      if (this.$refs.payWithPointsComponent.is_pay_with_points_enabled)
        isAllowed.push(!this.$refs.payWithPointsComponent.v$.$invalid)


      return !isAllowed.includes(false);
    },
    validateRadius() {
      let isAllowed = true;

      const fieldRequiredError = "This field is required.";

      if (this.form.radius_enable && !this.settings.radius) {
        this.updateErrors("radius", fieldRequiredError);
        isAllowed = false;
      }


      return isAllowed;
    },
    validateBankAccounts() {
      let newBankAccounts = [];

      if (this.settings.bank_accounts.length > 0) {
        newBankAccounts = _.cloneDeep(
          this.settings.bank_accounts.map(
            ({ ...keepAttrs }) => keepAttrs
          )
        );
      }

      const requiredFieldMessage = "is required.";
      const validationErrors = [];

      if (this.isPaymentFacility) {
        newBankAccounts.forEach(function (obj, index) {
          const objError = {
            bank: !obj.bank ? `Bank ${requiredFieldMessage}` : null,
            account_name: !obj.account_name ? `Account name ${requiredFieldMessage}` : null,
            account_no: !obj.account_no ? `Account no ${requiredFieldMessage}` : null
          };

          if (/[^a-zA-Z0-9\-/ ]/.test(obj.account_name)) {
            objError["account_name"] = "Special characters are not allowed for account name.";
          }

          validationErrors[index] = objError;
        });
      }

      this.updateErrors("paymentFacilities", validationErrors);

      return validationErrors.flatMap(error => _.values(error).filter(error => error)).length === 0;
    },
    validateFees() {
      let newFees = [];

      if (this.settings.fees.length > 0) {
        newFees = _.cloneDeep(
          this.settings.fees.map(({ ...keepAttrs }) => keepAttrs)
        );
      }

      const requiredFieldMessage = "is required.";
      const validationErrors = [];

      newFees.forEach(function (obj, index) {
        const objError = {
          name: !obj.name ? `Fee name ${requiredFieldMessage}` : null,
          value_type: !obj.value_type ? `Value type ${requiredFieldMessage}` : null,
          value: !obj.value ? `Value ${requiredFieldMessage}` : null
        };

        if (/[^a-zA-Z0-9\-/ ]/.test(obj.name)) {
          alert("Special characters are not allowed for Fee name.");
        }

        validationErrors[index] = objError;
      });

      this.updateErrors("fees", validationErrors);

      return validationErrors.flatMap(error => _.values(error).filter(error => error)).length === 0;;
    },
    validateCancelOrderButton() {
      if (this.form.cancel_order_enable) {
        this.cancelOptionErrors = {}; // always reset cancel option errors
        this.form.cancellationOptions.map((reason, index) => {
          if (reason.value === null && reason.identifier === null) {
            this.$set(
              this.cancelOptionErrors,
              index,
              "Select a reason"
            );
          } else if (
            reason.identifier === 0 &&
            this.$refs.CancelOrderButtonSection.$refs[`custom_reason_${index}`] &&
            !this.$refs.CancelOrderButtonSection.$refs[`custom_reason_${index}`][0].$el.value
          ) {
            this.$set(
              this.cancelOptionErrors,
              index,
              "Enter a reason"
            );
          }
        });
        return Object.keys(this.cancelOptionErrors).length === 0;
      }
    },
    validateSpecialDiscounts() {
      const allowed = [];
      if (this.settings.special_discount_enable) {
        if (this.settings.special_discount[0].channels.length == 0) {
          this.special_discounts.sdChannelsError = true;
          allowed.push(false);
        } else {
          this.special_discounts.sdChannelsError = false;
        }

        if (
          this.settings.special_discount[0].discount_types.length == 0
        ) {
          this.special_discounts.sdDiscountTypesError = true;
          allowed.push(false);
        } else {
          this.special_discounts.sdDiscountTypesError = false;
        }

        if (!this.settings.special_discount[0].discount_terms) {
          this.special_discounts.sdDiscountTermsError = true;
          allowed.push(false);
        } else if (
          this.settings.special_discount[0].discount_terms ==
          "per_item" &&
          !this.settings.special_discount[0].discount_terms_item
        ) {
          this.special_discounts.sdDiscountTermsItemError = true;
          allowed.push(false);
        } else {
          this.special_discounts.sdDiscountTermsItemError = false;
          this.special_discounts.sdDiscountTermsError = false;
        }

        if (
          !this.special_discounts.sdChannelsError &&
          !this.special_discounts.sdDiscountTypesError &&
          !this.special_discounts.sdDiscountTermsError &&
          !this.special_discounts.sdDiscountTermsItemError
        ) {
          allowed.push(true);
        }
      }
      return allowed;
    },
    validateCancelOrderVisibilitySettings() {
      let isAllowed = true;
      this.$root.$emit("validateCancelOrderVisibilitySettings");

      if (this.form.cancel_order_enable)
        isAllowed = !this.$refs.CancelOrderButtonSection.$refs.cancelVisibilitySettings.$v.$invalid;

      return isAllowed;
    },
    async validateData() {
      let allowed = [];

      if (this.isEnabledPointsView) allowed.push(await this.validatePointsSection());
      allowed.push(await this.validateRadius());
      if (this.isPaymentFacility) allowed.push(await this.validateBankAccounts());
      allowed.push(await this.validateFees());
      allowed.push(await this.validateCancelOrderButton());
      allowed.concat(await this.validateSpecialDiscounts());
      allowed.push(await this.validateCancelOrderVisibilitySettings());

      if (!allowed.includes(false)) {
        this.showModal();
      }
    },
    composeNewCategoriesParam() {
      let newCategories = [];

      if (this.settings.categories.length > 0) {
        newCategories = _.cloneDeep(
          this.settings.categories
            .map(({ id, merchant_uuid, ...keepAttrs }) => keepAttrs)
            .filter(({ name }) => !!name)
        );
      }

      for (const newCategory of newCategories) {
        newCategory.sub_categories = newCategory.sub_categories
          .filter(({ name }) => !!name);
      }

      return newCategories;
    },
    composeNewBrandCategoriesParam() {
      let newBrandCategories = [];

      if (this.settings.brand_categories.length > 0) {
        newBrandCategories = _.cloneDeep(
          this.settings.brand_categories
            .map(({ id, merchant_uuid, ...keepAttrs }) => keepAttrs)
            .filter(category => category.name != "")
        );
      }

      return newBrandCategories;
    },
    composeNewBankAccountsParam() {
      let newBankAccounts = [];

      if (this.settings.bank_accounts.length > 0) {
        newBankAccounts = _.cloneDeep(
          this.settings.bank_accounts.map(
            ({ ...keepAttrs }) => keepAttrs
          )
        );
      }

      return newBankAccounts;
    },
    composeNewFeesParam() {
      let newFees = [];

      if (this.settings.fees.length > 0) {
        newFees = _.cloneDeep(
          this.settings.fees.map(({ ...keepAttrs }) => keepAttrs)
        );
      }

      return newFees;
    },
    composeNewBrandsParam() {
      let newBrands = [];

      if (this.brands.length > 0) {
        newBrands = this.brands.map(obj => {
          return obj.uuid;
        });
      }

      return newBrands;
    },
    composePaymentTypeParam() {
      const available_mode_of_payment = this.paymentOptionsDisplay.map(({ value }) => value);

      return this.settings.payment_type.filter(type =>
        available_mode_of_payment.includes(type)
      )
    },
    composePaymentExpressChannelsParam() {
      if (this.form.is_payment_express_enabled) return this.detail.settings.payment_express_channels;
      else return [];
    },
    composeSpecialDiscountParam() {
      return [
        {
          channels: this.settings.special_discount[0].channels,
          discount_types: this.settings.special_discount[0]
            .discount_types,
          discount_terms: this.settings.special_discount[0]
            .discount_terms,
          discount_terms_item:
            this.settings.special_discount[0].discount_terms ==
              "per_item"
              ? this.settings.special_discount[0]
                .discount_terms_item
              : "",
          is_enabled:
            this.settings.special_discount_enable / 1
        }
      ];
    },
    composeCancelOrderButtonParam() {
      const param = {};
      param[
        "cancellation_reasons"
      ] = this.form.cancellationOptions.map((option, index) => {
        return option.identifier === 0
          ? this.$refs.CancelOrderButtonSection.$refs[`custom_reason_${index}`][0].$el.value
          : option.value;
      });

      const isCancelButtonAlwaysShow = Boolean(this.$refs.CancelOrderButtonSection.$refs.cancelVisibilitySettings.form.disable_cancel);

      param["disable_cancel"] = !isCancelButtonAlwaysShow;

      if (!isCancelButtonAlwaysShow) param["disable_cancel_seconds"] = this.$refs.CancelOrderButtonSection.$refs.cancelVisibilitySettings.form.disable_cancel_seconds;

      return param;
    },
    composePayWithPointsParam() {
      const selectedChannels = [
        "pay_with_points_estore_enabled",
        "pay_with_points_sto_enabled",
        "pay_with_points_stp_enabled",
        "pay_with_points_ca_enabled"
      ].map(channel => this.pay_with_points_setup[channel]);

      if (!selectedChannels.includes(true)) {
        return {
          ...this.pay_with_points_setup,
          pay_with_points_currency: null,
          pay_with_points_currency_value: null,
          pay_with_points_value: null
        }
      } else return this.pay_with_points_setup;
    },
    async sendForm() {
      this.setErrors(null);

      let param = {
        points_same_as_merchanics: this.settings
          .points_same_as_merchanics,
        points_currency: this.settings.points_currency,
        points_currency_value: this.settings.points_currency_value,
        points_value: this.settings.points_value,
        store_name: this.settings.store_name,
        store_description: this.settings.store_description,
        categories_enable: this.settings.categories_enable,
        payment_type: this.composePaymentTypeParam(),
        categories: this.composeNewCategoriesParam(),
        brand_categories_enable: 1, // this.settings.brand_categories_enable,
        brand_categories: this.composeNewBrandCategoriesParam(),
        bank_accounts: this.composeNewBankAccountsParam(),
        fees: this.composeNewFeesParam(),
        brands: this.composeNewBrandsParam(),
        brand_enable: this.enable / 1,
        radius: this.settings.radius,
        radius_enable: this.form.radius_enable,
        limited_stock: this.enabledSku,
        cancel_order_enable: this.form.cancel_order_enable,
        is_payment_express_enabled: this.form
          .is_payment_express_enabled,
        payment_express_channels: this.composePaymentExpressChannelsParam(),
        "special_discount.enable":
          this.settings.special_discount_enable / 1,
        points_expiry: this.form.points_expiry,
        points_expiry_duration: this.form.points_expiry_duration,
        points_earning_enabled: this.form.points_earning_enabled
      };

      param["special_discount"] = { ...this.composeSpecialDiscountParam() };

      if (this.form.cancel_order_enable) {
        param = { ...param, ...this.composeCancelOrderButtonParam() };
      } else {
        param["disable_cancel"] = false;
      }

      param = { ...param, ...this.composePayWithPointsParam() };

      let _this = this;
      await this.$store
        .dispatch("estoreSettings/saveSettings", param)
        .then(function () {
          if (_this.errors == null) {
            _this.hideModal();
            _this.viewSettings();
            _this.mop = _this.settings.payment_type;
          } else {
            _this.hideModal();
          }
        });
    },
    pointsFormatter(value, event) {
      return event === null ? value : value * 1;
    },
    addCategory() {
      this.settings.categories.push({
        uuid: null,
        name: "",
        sub_categories: [
          {
            uuid: "",
            name: ""
          }
        ]
      });
    },
    addSubCategory(index, sub_index) {
      let subCategory = "sub_category_" + index + "_" + sub_index;
      let lastItem = this.$refs[subCategory][0].$el;
      if (lastItem.value != "") {
        this.settings.categories[index].sub_categories.push({
          uuid: "",
          name: ""
        });
      } else {
        lastItem.focus();
      }
    },
    deleteCategory(index) {
      this.settings.categories.splice(index, 1);
    },
    deleteSubCategory(index, sub_index) {
      this.settings.categories[index].sub_categories.splice(sub_index, 1);
    },
    addBrandCategory() {
      this.settings.brand_categories.push({
        uuid: null,
        name: "",
        sub_categories: [
          {
            uuid: "",
            name: ""
          }
        ]
      });
    },
    addBrandSubCategory(index, sub_index) {
      let subCategory = "brand_sub_category_" + index + "_" + sub_index;
      let lastItem = this.$refs[subCategory][0].$el;
      if (lastItem.value != "") {
        this.settings.brand_categories[index].sub_categories.push({
          uuid: "",
          name: ""
        });
      } else {
        lastItem.focus();
      }
    },
    deleteBrandCategory(index) {
      this.settings.brand_categories.splice(index, 1);
    },
    deleteBrandSubCategory(index, sub_index) {
      this.settings.brand_categories[index].sub_categories.splice(
        sub_index,
        1
      );
    },
    addPaymentFacility() {
      const hasPreviousErrors = this.errors && this.errors.errors.paymentFacilities;

      if (hasPreviousErrors) delete this.errors.errors.paymentFacilities;

      if (this.settings.bank_accounts.length <= 4) {
        this.settings.bank_accounts.push({
          bank: "",
          account_no: "",
          account_name: "",
          uuid: ""
        });
      } else {
        alert("Only 5 banks are allowed.");
      }

      if (hasPreviousErrors) this.validateBankAccounts();
    },
    deletePaymentFacility(index) {
      this.settings.bank_accounts.splice(index, 1);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    async evaluateSameAsMechanics(value, type = null) {
      if (value / 1) {
        await this.$store.dispatch("points/getDetails");

        const { amount, currency, points, redeem_points, redeem_amount, redeem_currency } = this.$store.state.points.details;
        if (!type) {
          this.settings.points_value = points;
          this.settings.points_currency = currency;
          this.settings.points_currency_value = amount;
        }
        this.pay_with_points_setup = {
          ...this.pay_with_points_setup,
          pay_with_points_value: redeem_points,
          pay_with_points_currency: redeem_currency,
          pay_with_points_currency_value: redeem_amount
        };
      };
    },
    setPayWithPoints({ pay_with_points_value, pay_with_points_currency, pay_with_points_currency_value, selectedChannels }) {
      this.pay_with_points_setup = {
        pay_with_points_value,
        pay_with_points_currency,
        pay_with_points_currency_value
      };

      [
        "pay_with_points_estore_enabled",
        "pay_with_points_sto_enabled",
        "pay_with_points_stp_enabled",
        "pay_with_points_ca_enabled"
      ].forEach(channel => this.pay_with_points_setup[channel] = selectedChannels.includes(channel));
    },
    controlValue(field, direction, refI) {
      const { min, max } = this.$refs[refI];
      let valNum = Number(this.settings[field]);

      if (direction === "up" && valNum < max) {
        this.settings[field]++;
      } else if (direction === "down" && valNum >= min) {
        this.settings[field]--;
      }
    },
    trimExcessMaxLength(evt) {
      if (evt.target.value.length >= evt.target.maxLength) {
        evt.preventDefault();
      }
    },
    updateErrors(key, value) {
      this.$nextTick(() => {
        const errors = (this.errors && !_.isEmpty(this.errors.errors) && { ...this.errors.errors }) || {};
        errors[key] = value;
        this.setErrors({ errors });
      });
    }
  }
};
</script>
<style lang="scss">
.invalid-feedback {
  display: block;
}

#category-switch {
  .vue-switcher input {
    top: 14px;
    height: 25%;
  }
}

.custom-checkbox .custom-control-label::before {
  top: 5px !important;
}

.custom-control-label::after {
  top: 5px !important;
}

#bank-account-container {
  border: 1px solid #e1e3e8;
  border-radius: 4px;
  cursor: pointer;

  .bank-name-container {
    padding: 14px 24px;
    border-bottom: 1px solid #e1e3e8;
    height: 46px;

    display: flex;
    align-items: center;

    span {
      flex: 1;
    }
  }

  .bank-form {
    padding: 14px 24px;
  }
}

#fees-container {
  .fees-collapse-container {
    border: 1px solid #e1e3e8;
    border-radius: 4px;

    .fee-header {
      display: flex;
      border-bottom: 1px solid #e1e3e8;
      height: 50px;
      padding: 14px 24px;

      .fee-title {
        flex: 1;
        border: none;
        cursor: pointer;
      }
    }
  }
}

.form-control:disabled {
  background-color: #e9ecef !important;
  opacity: 1;
}
</style>

<style lang="scss" scoped>
.settings-tab {
  font-family: MainFontRegular, sans-serif !important;
}

#app-content .content-body .content-inside {
  padding-bottom: 100px;
}

.sd-dc-terms {
  margin: 0 0 0 20px;
}

.input-controls {
  right: 10px;
  justify-content: center;

  &>.btn {
    padding: 0;
    width: 9px;
    height: 6.5px;
    background: transparent url('~@/assets/images/spinner-control.png') no-repeat 100%;
    border: 0;
    box-shadow: none;
    margin: 1px 0;

    &:active,
    &:focus:active {
      background: transparent url('~@/assets/images/spinner-control.png') no-repeat 100%;
      box-shadow: none;
    }

    &.-down {
      transform: rotate(180deg);
    }
  }
}
</style>
